import { Alert, Button, Divider, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ModelPage from "../../../../../layout/ModelPage";
import { notification } from "../../../../../context/actions/notificationActions";
import { startCargarDocumentoConcesionados } from "../../../../../context/actions/pagos2Actions";
import {
  composeErrorNotification,
} from "../../../../../utils/composeNotification";

export default function ModalCargarDocumentoConcesionado({
  visible,
  onClose,
  ordenPagoID,
  onSuccess,
  autorizacionClienteUri,
  facturaUri,
  facturaXMLUri,
  verificacionFacturaUri
}) {
  const dispatch = useDispatch();
  const [body, setBody] = useState({});
  const [loading, setLoading] = useState(false);

  const necesitaAutorizacion = !autorizacionClienteUri;
  const necesitaFactura = !facturaUri || !facturaXMLUri || !verificacionFacturaUri;

  const estaVacioNull = (valor) => {
    if (valor === "" || valor === null || valor === undefined) {
      return true;
    }
    return false;
  };

  const camposError = () => {
    const tieneAutorizacion = !estaVacioNull(body.file);

    const tieneFacturaPDF = !estaVacioNull(body.facturaPDF);
    const tieneFacturaXML = !estaVacioNull(body.facturaXML);
    const tieneVerificacion = !estaVacioNull(body.verificacionFactura);

    const cantidadFacturasCargadas = [tieneFacturaPDF, tieneFacturaXML, tieneVerificacion].filter(Boolean).length;

    const facturaValida = cantidadFacturasCargadas === 0 || cantidadFacturasCargadas === 3;

    const facturaIncompleta = cantidadFacturasCargadas > 0 && cantidadFacturasCargadas < 3;
    const noCargóNada = !tieneAutorizacion && cantidadFacturasCargadas === 0;

    const error = facturaIncompleta || noCargóNada;

    return error;
  };

  const uploadProps = {
    beforeUpload: (selectedFile) => {
      setBody({ ...body, file: selectedFile });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const props1 = {
    beforeUpload: (facturaPDF) => {
      setBody({ ...body, facturaPDF });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const props2 = {
    beforeUpload: (facturaXML) => {
      setBody({ ...body, facturaXML });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const props3 = {
    beforeUpload: (verificacionFactura) => {
      setBody({ ...body, verificacionFactura });
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const handleClick = async () => {
    if (camposError()) {
      dispatch(
        notification(
          composeErrorNotification("Error", "Todos los archivos son requeridos")
        )
      );
      return;
    }

    setLoading(true);

    try {
      const formdata = new FormData();

      if (necesitaAutorizacion && body.file) {
        formdata.append("File", body.file);
      }

      formdata.append("OrdenPagoID", ordenPagoID);

      if (necesitaFactura) {
        if (body.facturaPDF) {
          formdata.append("FacturaPDF", body.facturaPDF);
        }
        if (body.facturaXML) {
          formdata.append("FacturaXML", body.facturaXML);
        }
        if (body.verificacionFactura) {
          formdata.append("VerificacionFactura", body.verificacionFactura);
        }
      }

      const result = await dispatch(startCargarDocumentoConcesionados(formdata));

      if (result.success) {
        setBody({});
        if (onSuccess) {
          await onSuccess();
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setBody({});
    onClose();
  };

  return (
    <ModelPage
      titulo={`Cargar Documento Concesionado - OP ${ordenPagoID}`}
      isVisible={visible}
      handleOk={handleClick}
      handleCancel={handleCancel}
      confirmLoading={loading}
      className="pagos-v2-modal"
      width={400}
    >
      <div style={{ textAlign: "center" }}>
        {necesitaAutorizacion && (
          <>
            <div className="tituloPequeño">Documento de Autorización Concesionado</div>

            <Upload {...uploadProps} style={{ width: "100%" }}>
              <Button
                style={{ marginTop: 20 }}
                icon={<UploadOutlined />}
              >
                Seleccione documento
              </Button>
            </Upload>
            <div style={{ marginTop: 8 }}>{body.file?.name}</div>

            {necesitaFactura && <Divider />}
          </>
        )}

        {necesitaFactura && (
          <>
            <div className="tituloPequeño">Factura PDF emitida por el proveedor</div>

            <Upload {...props1} style={{ width: "100%" }}>
              <Button
                style={{ marginTop: 20 }}
                icon={<UploadOutlined />}
              >
                Seleccione documento
              </Button>
            </Upload>
            <div style={{ marginTop: 8 }}>{body.facturaPDF?.name}</div>

            <Divider />
            <div className="tituloPequeño">Factura XML emitida por el proveedor</div>

            <Upload {...props2} style={{ width: "100%" }}>
              <Button
                style={{ marginTop: 20 }}
                icon={<UploadOutlined />}
              >
                Seleccione documento
              </Button>
            </Upload>
            <div style={{ marginTop: 8 }}>{body.facturaXML?.name}</div>

            <Divider />
            <div className="tituloPequeño">
              Verificacion de factura por SAT
            </div>
            <div style={{ marginTop: 8, display: "inline-block" }}>
              <Alert
                type='warning'
                showIcon
                style={{ fontSize: "11px" }}
                message={"Por favor verifica que los folios fiscales coincidan"}
              />
            </div>

            <Upload {...props3} style={{ width: "100%" }}>
              <Button
                style={{ marginTop: 20 }}
                icon={<UploadOutlined />}
              >
                Seleccione documento
              </Button>
            </Upload>
            <div style={{ marginTop: 8 }}>{body.verificacionFactura?.name}</div>
          </>
        )}
      </div>
    </ModelPage>
  );
}
